import React from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, NavLink} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Logo from './../assets/img/logo2.png';
import Warehouse from './../assets/img/warehouse.png';
import Cart from './../assets/img/cart.svg';

export default function Header({back, bottom}) {
  const history = useHistory();
  const [collapse, setCollapse] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <>
      <div style={{
        backgroundColor: '#ffffff',
        marginBottom: (!bottom) ? '0px' : `10px`
      }}>
        <Navbar color="faded" light>
          {
            (back) ? <> 
              <NavbarBrand className="me-auto" onClick={() => history.goBack()}>
                <i className="fas fa-arrow-left"/>
              </NavbarBrand>
            </>: <> 
              <NavbarBrand className="me-auto" href="/">
                <img alt="..." width={42} src={Logo} />
              </NavbarBrand>
            </>
          }

          <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={'down'}>
            <DropdownToggle 
              caret 
              style={{
                backgroundColor: 'white',
                color: 'black',
              }}
            >
              <img
                alt="warehouse"
                style={{
                  width: '1.5em',
                  marginRight: '10px'
                }}
                src={Warehouse}
              />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem> 
                <Link style={{
                  color: 'black',
                  textDecoration: 'none'
                }} to="/transit"> Transito </Link>
              </DropdownItem>

              <DropdownItem> 
                <Link style={{
                  color: 'black',
                  textDecoration: 'none'
                }} to="/outlet"> Oportunidad </Link>
              </DropdownItem>


            </DropdownMenu>
          </Dropdown>

           <div>
            <Link style={{
              display: "block"
            }}
            to="/cart"> 
              <img 
                alt="cart" 
                style={{
                  width: '1.5em',
                  marginRight: '10px'
                }}
                src={Cart}/>
            </Link>
          </div>

          <NavbarToggler
            className="me-2"
            style={{
              border: '0',
              fontSize: '15px'
            }}
            onClick={() => setCollapse(!collapse)}
          />
            <Collapse navbar isOpen={collapse}>
              <Nav navbar>
                <NavItem>
                  <NavLink href="/home">
                    Inicio
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/seller">
                    Vendedor
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
        </Navbar>
      </div>
    </>
  )
}

